import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICommitSearchResult } from '../shared/commitSearch';

@Injectable()
export class CommitTrackerService {

  constructor(private http: HttpClient) { }

  search(workItemId: number): Observable<ICommitSearchResult> {
    return this.http.get<ICommitSearchResult>(`/api/commitsearch?workItemId=${workItemId}`);
  }
}
